import { loadProgress } from '../state/store';

export function LoadingBar() {
  const p = loadProgress.value;
  if (p >= 1) return null;
  return (
    <div class="loading" role="progressbar" aria-label="Loading the body" aria-valuemin={0} aria-valuemax={100} aria-valuenow={Math.round(p * 100)} data-testid="loading">
      <div class="loading-fill" style={{ width: `${Math.max(4, p * 100)}%` }} />
      <span>{p === 0 ? 'Loading the skeleton…' : 'Adding muscles, organs and nerves…'}</span>
    </div>
  );
}
